
<form [formGroup]="agregarFormCondicion">
  <div class="row">
    <div class="col-lg-12">
      <app-lfsa-input [control]="this.agregarFormCondicion.get('id_promo')" [id]="'id_promo'"
        [isReadOnly]="true" [label]="'ID PROMO'" formControlName="id_promo" type="text">
      </app-lfsa-input>
    </div>

    <div class="col-lg-12 mb-5">
      <label for="id_tiers">Seleccione Tier</label>
      <select class="form-control" formControlName="id_tiers" id="id_tiers">
        <option value="">Seleccione una opción</option>
        <option *ngFor="let data of comboTier" [value]="data.idTiers">{{ data.idTiers + ' - ' + data.descripcion }}</option>
      </select>
    </div>
  </div>

  <app-lfsa-botones-formulario (devolverAccion)="accionesCondOficinaVenta( $event )"
    [formularioValido]="(!agregarFormCondicion.invalid) ? false : true"
    [textBoton]="'Guardar'" class="row">
  </app-lfsa-botones-formulario>  
</form>
